/** UrbanMap design tokens — shared across all UM prototypes */
export const UM = {
  // Backgrounds
  bg: '#ffffff',
  bgHeader: '#f8fafc',
  bgHover: '#f1f5f9',

  // Borders
  border: '#e2e8f0',

  // Text
  text: '#1e293b',
  textMuted: '#64748b',
  textDim: '#94a3b8',

  // Accent
  accent: '#009de9',
  accentLight: '#e0f2fe',

  // Quality dots
  green: '#16a34a',
  orange: '#f97316',
  slate: '#94a3b8',

  // Badge backgrounds
  badgeBlue: '#dbeafe',
  badgeBlueText: '#1d4ed8',
  badgePurple: '#f3e8ff',
  badgePurpleText: '#7e22ce',
  badgeCyan: '#e0f2fe',
  badgeCyanText: '#0369a1',
} as const;
